import TableText from "@/components/table/TableText";
import { Button, DatePicker, Input, message, Row, Spin, Table, Radio } from 'antd';
import FileSaver from "file-saver";
import moment from 'moment';
import React, { Component } from 'react';
import getJson from '../../../../method';
import Auth from "../../Auth";
import imgSave from "../../saveImg";
import { compute, SPR, computeYear } from "./compute";
import { defaultData, columnsYear } from './data';
import Table4_2_2 from "./4-2-2";
import './index.scss';

const { TextArea } = Input;
const { MonthPicker } = DatePicker;

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            note: {
                comments: ''
            },
            loading: true,
            print: false,
            loadingSave: false,
            loadingNote: false,
            lastYearData: [],
            sprData: [],
            fullYear: 0,
            // 1 春节 2 五一 3 十一
            holiday: 0
        }
    }


    componentDidMount() {
        this.getData(this.state.date, this.state.fullYear);
    }



    computeNum = (data, lastYearData, sprData) => {
        data = compute(data, lastYearData, this.state.date, sprData);
        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data, this.state.lastYearData);
    }

    getData = (date, _fullYear) => {
        let data = JSON.parse(JSON.stringify(defaultData));
        const month = moment(date).format('M');
        let lastMonth = month;
        if (month == SPR[moment(date).format('Y')].m) lastMonth = SPR[moment(date).subtract(1, 'year').format('Y')].m;

        fetch(`/_4_2_daily?year=${moment(date).format('YYYY')}&month=${month}&lastmonth=${lastMonth}&type=${_fullYear}`, { credentials: 'include' })
            .then(x => x.json()).then(x => {
                if (_fullYear == 1) {
                    let data = x.data.data || [];
                    let lastYearData = x.data.lastYearData || [];
                    data.push({
                        name: "Total"
                    });
                    lastYearData.push({
                        name: "Total"
                    });
                    // 计算全年
                    this.setState({
                        loading: false,
                        note: x.data.comments || { comments: "" },
                        data: computeYear(data, lastYearData)
                    });
                    return
                }

                if (x.data.data && x.data.data.length) {
                    data = x.data.data;
                }

                const listName = ['ava', 'sold', 'occ', 'adr', 'revpar', 'rev'];
                const grandName = ["grand_rms", "grand_rn", "grand_occ", "grand_arr", "grand_revpar", "grand_rev",];
                const monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',];
                listName.forEach((name, i) => {
                    data[33][name] = getJson([(month - 1) * 3 + 1, grandName[i]], x.data.data4_1);
                    data[31][name] = getJson([i + 1, monthName[month - 1]], x.data.data2_1)
                });
                data[31]['total'] = getJson([9, monthName[month - 1]], x.data.data2_1);
                this.setState({
                    loading: false,
                    note: x.data.comments || { comments: "" },
                    lastYearData: x.data.lastYearData || [],
                    sprData: x.data.sprData || []
                });
                this.computeNum(data, x.data.lastYearData, x.data.sprData)
            }).catch(err => {
                console.error(err);
                this.setState({ loading: false });
            })
    }

    onSave = () => {


        let { date, data, note, fullYear } = this.state;
        if (fullYear == 1) {
            message.error('请切换至当月保存数据！');
            return
        }
        this.setState({ loadingSave: true });
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        data = data.map(x => ({ ...x, year, month }));
        note = { ...note, year, month };

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        dataFrom.append('note', JSON.stringify(note));
        dataFrom.append('year', year);
        dataFrom.append('month', month);

        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_4_2_daily', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table7_6', 1.5, '4.20', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} 4.2 Daily Report 日报表`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4_2').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { data, date, note, print, loading, loadingNote, fullYear } = this.state;
        const columns = [{
            title: 'Date',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 100,
            render: (text, record, index) => {

                const props = { text, index, type: 'text', name: "name", };
                return <TableText data={props} />
            }
        }, {
            title: 'Week',
            dataIndex: 'week',
            key: 'week',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                const week = ['', '周一', '周二', '周三', '周四', '周五', '周六', '周日'][moment(`${date}-${index + 1}`).format('E')];
                const props = { text: week, index, type: 'text', name: "name", };
                return <TableText data={props} />
            }
        }, {
            title: 'Available room',
            dataIndex: 'ava',
            key: 'ava',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, onChange: this.onChange, type: index < 31 && !print ? 'inputNumber' : 'number', name: "ava",
                    compared: {
                        title: ['Available room'],
                        record,
                        sqlName: "_4_2_daily"
                    }
                };
                return <TableText data={props} />
            }
        }, {
            title: 'Sold Room',
            dataIndex: 'sold',
            key: 'sold',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, onChange: this.onChange, type: index < 31 && !print ? 'inputNumber' : 'number', name: "sold", compared: {
                        title: ['Sold Room'],
                        record,
                        sqlName: "_4_2_daily"
                    }
                };
                return <TableText data={props} />
            }
        }, {
            title: 'Occupancy %',
            dataIndex: 'occ',
            key: 'occ',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, onChange: this.onChange, type: 'percent', name: "occ", compared: {
                        title: ['Occupancy %'],
                        record,
                        sqlName: "_4_2_daily"
                    }
                };
                return <TableText data={props} />
            }
        }, {
            title: 'ADR',
            dataIndex: 'adr',
            key: 'adr',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, onChange: this.onChange, type: 'number', name: "adr", compared: {
                        title: ['ADR'],
                        record,
                        sqlName: "_4_2_daily"
                    }
                };
                return <TableText data={props} />
            }
        }, {
            title: 'RevPAR',
            dataIndex: 'revpar',
            key: 'revpar',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, onChange: this.onChange, type: 'number', name: "revpar", compared: {
                        title: ['RevPAR'],
                        record,
                        sqlName: "_4_2_daily"
                    }
                };
                return <TableText data={props} />
            }
        }, {
            title: 'Room Revenue',
            dataIndex: 'rev',
            key: 'rev',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, onChange: this.onChange, type: index < 31 && !print ? 'inputNumber' : 'number', name: "rev", compared: {
                        title: ['Room Revenue'],
                        record,
                        sqlName: "_4_2_daily"
                    }
                };
                return <TableText data={props} />
            }
        }, {
            title: 'Room Revenue %',
            dataIndex: 'revper',
            key: 'revper',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, onChange: this.onChange, type: 'percent', name: "revper", compared: {
                        title: ['Room Revenue %'],
                        record,
                        sqlName: "_4_2_daily"
                    }
                };
                if (index == 33) props.type = '';
                return <TableText data={props} />
            }
        }, {
            title: 'Hotel Total Revenue',
            dataIndex: 'total',
            key: 'total',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text, index, onChange: this.onChange, type: index < 31 && !print ? 'inputNumber' : 'number', name: "total", compared: {
                        title: ['Hotel Total Revenue'],
                        record,
                        sqlName: "_4_2_daily"
                    }
                };
                if (index == 33) props.type = '';
                return <TableText data={props} />
            }
        }];
        const user = JSON.parse(sessionStorage.getItem('user') || "{}")
        return (
            <Spin spinning={loading}>
                <div className="table7_1_1 table7_6" id="table7_6" style={{ height: 'auto' }}>
                    <Row className="title">
                        <Row>4.2.1 Daily Report 日报表</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getData(str, fullYear)
                                }}
                            />
                            <Radio.Group
                                style={{ marginLeft: 10 }}
                                onChange={e => {
                                    const _fullYear = e.target.value;
                                    this.setState({
                                        data: [],
                                        loading: true,
                                        fullYear: _fullYear
                                    }, () => {
                                        this.getData(date, _fullYear)
                                    });
                                }} value={fullYear}>
                                <Radio value={1}>全年</Radio>
                                <Radio value={0}>当月</Radio>
                            </Radio.Group>
                        </Row>
                        <Table
                            columns={fullYear == 0 ? columns : columnsYear.map(x => {
                                return {
                                    ...x,
                                    dataIndex: x.key,
                                    align: "center",
                                    width: 100,
                                    render: (text, record, index) => {
                                        const props = { text, index, type: x.type ? x.type : "number", name: x.key, };
                                        return <TableText data={props} />
                                    }
                                }
                            })}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            id="table4_2"
                            scroll={print ? {} : { y: 500 }}
                            rowKey={(record, index) => index}
                        />
                        <Button
                            type="primary"
                            style={{ float: 'right', marginTop: 20 }}
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.downloadExcel();
                                });
                            }}
                            loading={this.state.print}
                        >导出Excel</Button>
                    </Row>
                    <Row className="title">
                        <div className="chart-4-2">
                            <div id="chartOcc"></div>
                            <div id="chartAdr"></div>
                            <div id="chartRevpar"></div>
                            <div id="chartRoomRev"></div>
                        </div>

                        {!loading && < Row >Comments备注: </Row>}
                        {!loading && <TextArea
                            autosize={{ minRows: 4 }}
                            defaultValue={note.comments || ""}
                            onBlur={(e) => {
                                let n = this.state.note;
                                n['comments'] = e.target.value;
                                this.setState({
                                    note: n
                                })
                            }}

                        />}
                        <Auth loading={loading} auth="edit_4_2_1">
                            <Row className="table-footer-btn" style={{ display: print ? 'none' : "" }}>
                                <Button
                                    type="primary"
                                    style={{ marginRight: 10 }}
                                    onClick={this.downloadSG}
                                    loading={print}
                                >加入pdf</Button>
                                <Button
                                    type="primary"
                                    onClick={this.onSave}
                                    loading={loadingNote}
                                >保存</Button>
                            </Row>
                        </Auth>

                    </Row>
                </div>
                {(['5', '10'].includes(moment(date).format("M")) || SPR[moment(date).format('Y')].m == moment(date).format('M')) &&
                    <Table4_2_2 data={data} date={date} />
                }

            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2-daily/index.js